/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MotionSensor
 */
export interface MotionSensor {
    /**
     * 
     * @type {string}
     * @memberof MotionSensor
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof MotionSensor
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof MotionSensor
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof MotionSensor
     */
    vehicleDeviceId: string;
    /**
     * 
     * @type {Date}
     * @memberof MotionSensor
     */
    firmwareLastUpdatedAt: Date;
    /**
     * This current semantic version of the firmware.
     * @type {string}
     * @memberof MotionSensor
     */
    currentVersion: string;
}

/**
 * Check if a given object implements the MotionSensor interface.
 */
export function instanceOfMotionSensor(value: object): value is MotionSensor {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('vehicleDeviceId' in value) || value['vehicleDeviceId'] === undefined) return false;
    if (!('firmwareLastUpdatedAt' in value) || value['firmwareLastUpdatedAt'] === undefined) return false;
    if (!('currentVersion' in value) || value['currentVersion'] === undefined) return false;
    return true;
}

export function MotionSensorFromJSON(json: any): MotionSensor {
    return MotionSensorFromJSONTyped(json, false);
}

export function MotionSensorFromJSONTyped(json: any, ignoreDiscriminator: boolean): MotionSensor {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'vehicleDeviceId': json['vehicleDeviceId'],
        'firmwareLastUpdatedAt': (new Date(json['firmwareLastUpdatedAt'])),
        'currentVersion': json['currentVersion'],
    };
}

export function MotionSensorToJSON(json: any): MotionSensor {
    return MotionSensorToJSONTyped(json, false);
}

export function MotionSensorToJSONTyped(value?: MotionSensor | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'vehicleDeviceId': value['vehicleDeviceId'],
        'firmwareLastUpdatedAt': value['firmwareLastUpdatedAt'].toISOString(),
        'currentVersion': value['currentVersion'],
    };
}

